import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

class AuntiesApi {
  static getAunties({ nationality = '', gender = '' }) {
    const request = new Request(`${apiUrl}/content/aunties?nationality=${nationality}&gender=${gender}`, {
      method: 'GET',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }
}

export default AuntiesApi;
